export enum HEADER {
  PRODUCTS = 'Products',
  PRODUCTS_AND_APPS = 'Products and apps',
  FILTER = 'View all',
  PRODUCT = 'Product',
  PLAN = 'Plan',
  CLEAR_FILTER = 'Clear all filters',
  MONTHLY = 'Monthly',
  ANNUAL = 'Annual',
  SEARCH_PLACEHOLDER = 'Search for product or app',
  SEARCH_PLACEHOLDER_WITH_ADDONS = 'Search by name of product, app or add-on',
  APPS = 'Apps',
  SEARCH_APP_PLACEHOLDER = 'Search by app name',
}
